export default {
      id: "instagram-usage",
      viewBox: "0 0 19 22",
      url: __webpack_public_path__ + "img/icons.svg#instagram",
      toString: function () {
        return this.url;
      }
    }